
import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    inquiry: 'general',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('inquiry', formData.inquiry);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d62vsnabdoed7v0v8ibg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', inquiry: 'general', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-32 px-6 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-light mb-6 tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Get in Touch
          </h2>
          <p className="text-lg text-gray-600">
            Press inquiries, partnerships, and general questions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
              <i className="ri-mail-line text-3xl text-[#14B8A6]"></i>
            </div>
            <h4 className="font-light text-lg mb-2">Email</h4>
            <p className="text-gray-600 text-sm">info@caribbeanfashionfest.com</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
              <i className="ri-phone-line text-3xl text-[#14B8A6]"></i>
            </div>
            <h4 className="font-light text-lg mb-2">Phone</h4>
            <p className="text-gray-600 text-sm">+1 (809) 555-0123</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
              <i className="ri-instagram-line text-3xl text-[#14B8A6]"></i>
            </div>
            <h4 className="font-light text-lg mb-2">Social</h4>
            <p className="text-gray-600 text-sm">@caribbeanfashionfest</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="bg-white p-8 md:p-12" data-readdy-form id="contact-form">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <label className="block text-sm tracking-wide mb-2 text-gray-700">Name</label>
              <input 
                type="text"
                name="name"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
                className="w-full px-4 py-3 border border-gray-300 text-sm focus:outline-none focus:border-[#14B8A6] transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm tracking-wide mb-2 text-gray-700">Email</label>
              <input 
                type="email"
                name="email"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                required
                className="w-full px-4 py-3 border border-gray-300 text-sm focus:outline-none focus:border-[#14B8A6] transition-colors"
              />
            </div>
          </div>

          <div className="mb-6">
            <label className="block text-sm tracking-wide mb-2 text-gray-700">Inquiry Type</label>
            <select 
              name="inquiry"
              value={formData.inquiry}
              onChange={(e) => setFormData({...formData, inquiry: e.target.value})}
              className="w-full px-4 py-3 border border-gray-300 text-sm focus:outline-none focus:border-[#14B8A6] transition-colors cursor-pointer"
            >
              <option value="general">General Inquiry</option>
              <option value="press">Press & Media</option>
              <option value="partnership">Partnership</option>
              <option value="designer">Designer Application</option>
              <option value="vip">VIP Services</option>
            </select>
          </div>

          <div className="mb-6">
            <label className="block text-sm tracking-wide mb-2 text-gray-700">Message</label>
            <textarea 
              name="message"
              value={formData.message}
              onChange={(e) => setFormData({...formData, message: e.target.value})}
              required
              maxLength={500}
              rows={6}
              className="w-full px-4 py-3 border border-gray-300 text-sm focus:outline-none focus:border-[#14B8A6] transition-colors resize-none"
            ></textarea>
            <p className="text-xs text-gray-500 mt-2">{formData.message.length}/500 characters</p>
          </div>

          {submitStatus === 'success' && (
            <div className="mb-6 p-4 bg-[#14B8A6]/10 border border-[#14B8A6] text-[#14B8A6] text-sm">
              Thank you for your message. We'll be in touch soon.
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="mb-6 p-4 bg-red-50 border border-red-300 text-red-600 text-sm">
              Something went wrong. Please try again.
            </div>
          )}

          <button 
            type="submit"
            disabled={isSubmitting}
            className="w-full py-4 bg-black text-white text-sm tracking-widest hover:bg-gray-800 transition-colors disabled:opacity-50 cursor-pointer whitespace-nowrap"
          >
            {isSubmitting ? 'SENDING...' : 'SEND MESSAGE'}
          </button>
        </form>
      </div>
    </section>
  );
}
